import(/* webpackMode: "eager" */ "/data/web/oneroof-rebuild/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/data/web/oneroof-rebuild/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/avatar/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/breadcrumb/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/card/agent/button/email.js");
;
import(/* webpackMode: "eager", webpackExports: ["PageViewLayer"] */ "/data/web/oneroof-rebuild/src/app/_components/dataLayer/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/menu/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/reviewStar/star/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/_components/toggleBox/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/(agent)/agent/[slug]/_modules/fixedInfo/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/(agent)/agent/[slug]/_modules/info/card/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/(agent)/agent/[slug]/_modules/info/contact/content.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/(agent)/agent/[slug]/_modules/info/reviewTip/button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/(agent)/agent/[slug]/_modules/listings/content/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/(agent)/agent/[slug]/_modules/reviews/content.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/(agent)/agent/[slug]/_modules/stats/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/(agent)/agent/[slug]/_modules/testimonials/index.js");
